<template>
    <div class="full-wdith-box background-bg">
        <div class="close-btn" @click="clickCloseBtn">
            <span><font-awesome-icon icon="fa-solid fa-xmark" /></span>
        </div>

        <ReturnButton
            class="return-btn"
            @click="clickReturnBtn"
            v-show="viewPart != 'info'"
            :label="returnLabel"
        />

<!--        <div class="title-box">-->
<!--            <span></span>-->
<!--        </div>-->

        <div class="full-wdith-box" v-if="viewPart === 'info'">
            <el-scrollbar>
            <div class="img-part">
                <img :src="imgSrc" alt="photo">
            </div>

            <div class="companyname-part">
                {{companyname}}
            </div>

            <div class="name-part">
                <span>{{regionName}} {{obj.name}}</span>
            </div>

            <div>
                <div class="interaction-ui-round-1">
                    <div class="round-box" @click="clickChatBtn()">
                        <div class="interaction-icon">
                            <font-awesome-icon :icon="'fa-solid fa-comments'" />
                        </div>

                        <div class="interaction-title">
                            {{i18n.tkey("lang_open_personal_chat")}}
                        </div>
                    </div>

                    <div class="round-box" @click="clickCardBtn()">
                        <div class="interaction-icon">
                            <font-awesome-icon :icon="'fa-solid fa-address-card'" />
                        </div>

                        <div class="interaction-title">
                            {{i18n.tkey("lang_memberwork")}}
                        </div>
                    </div>

                    <div
                        class="round-box"
                        @click="clickShopsite()"
                        v-show="null != props.obj.acccompanycode && '' != props.obj.acccompanycode && -1 != props.obj.dinumber"
                    >
                        <div class="interaction-icon">
                            <font-awesome-icon :icon="'fa-solid fa-store'" />
                        </div>

                        <div class="interaction-title">
                            {{i18n.tkey("lang_shop_website_1")}}
                        </div>
                    </div>

                    <div
                        class="round-box"
                        @click="clickWebsite()"
                        v-if="null != props.obj.website && '' != props.obj.website"
                    >
                        <div class="interaction-icon">
                            <font-awesome-icon :icon="'fa-solid fa-arrow-up-right-from-square'" />
                        </div>

                        <div class="interaction-title">
                            {{i18n.tkey("lang_company_website")}}
                        </div>
                    </div>
                </div>
            </div>
            </el-scrollbar>
        </div>

        <div v-if="viewPart === 'card'" style="width: 100%;height: 100%;overflow-y: auto;overflow-x: hidden;">
            <cardDemo
                :cardId="obj.id"
                :isAllow="true"
                :userLogin="userInfoRef.login"
                :fullScreen="false"
                @sendMaterialChat="goMaterialChat"
            />
        </div>

        <div class="full-wdith-box chat-method-part-box" v-if="viewPart === 'chat'">
            <ChatMethodSelector
                :cardId="obj.id"
                @goShopopeeChat="goChatCallback"
            />
        </div>

    </div>
</template>

<script setup>

import {ref, computed, toRef, inject, getCurrentInstance} from "vue";
import myUtil from "@/util/util";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {useUserinfo} from "@/stores/userinfo";
import CardDemo from "@/views/cardDemo.vue";
import chatApi from "@/request/chatApi";
import ChatMethodSelector from "@/plugins/projectA/ui/chatMethodSelector.vue";
import ReturnButton from "@/components/shopopee/common/returnButton.vue";
import {getCountryObj} from "@/util/countrycode";

const props = defineProps(["obj"])
const emits = defineEmits(["goLogin", "goMaterialChat", "goChat", "clickClose"])

const publicPath = process.env.BASE_URL
const viewPart = ref("info")
const userInfoRef = toRef(useUserinfo())

const { proxy } = getCurrentInstance()
const i18n = inject("i18n")

const imgSrc = computed(() => {
    let src = `${publicPath}static/images/man.jpg?r=${proxy.$versionNum}`

    if (myUtil.isNotEmpty(props.obj.addinfo9)){
        src = props.obj.addinfo9
    }else{
        if (props.obj.memmale != 0) {
            src = `${publicPath}static/images/woman.jpg?r=${proxy.$versionNum}`
        }
    }

    return src
})

const returnLabel = computed(() => {
    let text = i18n.tkey("lang_return")

    return text
})

const regionName = computed(() => {
    let name = ""

    if (myUtil.isNotEmpty(props.obj.country)){
        const obj = getCountryObj(props.obj.country)

        name = obj[userInfoRef.value.lang]
        name += " - "
    }

    return name
})

const companyname = computed(() => {
    let name = props.obj.companyname2

    if (userInfoRef.value.lang === "zh" || userInfoRef.value.lang === "szh" || myUtil.isEmpty(name)){
        name = props.obj.companyname
    }

    return name
})

function goMaterialChat(login, url){
    emits("goMaterialChat", login, url)
}

function goChatCallback(obj) {
    emits("goChat", obj.login)
}

function clickCloseBtn(){
    emits("clickClose")
}

function clickChatBtn(){
    viewPart.value = "chat"
}

function clickCardBtn(){
    viewPart.value = "card"
}

function clickShopsite(){
    const url = myUtil.generateEshopopeeLoginAndJumpUrl(
        "/three",
        myUtil.isEmpty(userInfoRef.value.login) ? "" : userInfoRef.value.login,
        myUtil.isEmpty(userInfoRef.value.password) ? "" : userInfoRef.value.password,
        [props.obj.accCompanyCode]
    )

    myUtil.goURLNewWindow(url, "eshopopee")
}

function clickWebsite(){
    if (props.obj.website.indexOf("http") == -1){
        myUtil.goURLNewWindow("http://" + props.obj.website)
    }else{
        myUtil.goURLNewWindow(props.obj.website)
    }
}

function clickReturnBtn(){
    viewPart.value = "info"
}


</script>

<style scoped>

.full-wdith-box {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: relative;
    overflow-x: hidden;
    overflow-y: auto;
}

.chat-method-part-box {
    max-width: 800px;
    margin: auto;
}

.background-bg {
    background: #FAFCFF;
    padding-top: 36px;
    border-radius: 5px;
    border: 1px #E4E7ED solid;
}

@media screen and (min-width: 768px) {
    .img-part {
        width: 200px;
        height: 400px;
        position: relative;
        margin: auto;
    }
}

@media screen and (max-width: 768px) {
    .img-part {
        width: 180px;
        padding-top: 360px;
        position: relative;
        margin: auto;
    }
}


.img-part img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}

.name-part {
    text-align: center;
    font-size: 16px;
    //font-weight: 600;
    line-height: 2;
    margin-top: 12px;
    margin-bottom: 32px;
}

.companyname-part {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 2;
    margin-top: 12px;
    margin-bottom: 12px;
}

.icon-btn {
    width: 80px;
    height: 80px;
    background: #fff;
    border-radius: 50%;
}

.close-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 24px;
    cursor: pointer;
    z-index: 10;
}

.round-box {
    border-radius: 10px;
    border: 1px #E4E7ED solid;
    background: #F5F7FA;
    box-sizing: border-box;
    margin-right: 12px;
    padding: 5px;
    cursor: pointer;
    margin-bottom: 12px;
}

@media screen and (min-width: 768px) {
    .interaction-ui-round-1 {
        //opacity: 1;
        //animation: showInteractionUiRound 0.35s ease-out;
        //user-select: none;
        padding-left: 10px;
        display: flex;
        justify-content: center;
    }
}

@media screen and (max-width: 768px) {
    .interaction-ui-round-1 {
        //opacity: 1;
        //animation: showInteractionUiRound 0.35s ease-out;
        //user-select: none;
        padding-left: 10px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    }
}

@media screen and (min-width: 768px) {
    .interaction-ui-round-1 .interaction-icon {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background: rgb(255, 255, 255);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 30px;
        margin-left: 10px;
        margin-right: 10px;
        user-select: none;
        box-sizing: border-box;
        margin: auto;
    }

    .interaction-ui-round-1 .interaction-title {
        color: #fefefe;
        font-weight: 600;
        margin-top: 5px;
        font-size: 20px;
        width: 100px;
        text-shadow: 1px 1px 0 #2d3e4f, -1px -1px 0 #2d3e4f, 1px -1px 0 #2d3e4f, -1px 1px 0 #2d3e4f;
        user-select: none;

    }
}

@media screen and (max-width: 768px) {
    .interaction-ui-round-1 .interaction-icon {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: rgb(255, 255, 255);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 24px;
        margin-left: 8px;
        margin-right: 8px;
        user-select: none;
        box-sizing: border-box;
        margin: auto;
    }

    .interaction-ui-round-1 .interaction-title {
        color: #fefefe;
        font-weight: 600;
        margin-top: 5px;
        font-size: 16px;
        width: 80px;
        text-shadow: 1px 1px 0 #2d3e4f, -1px -1px 0 #2d3e4f, 1px -1px 0 #2d3e4f, -1px 1px 0 #2d3e4f;
        user-select: none;

    }
}

.return-btn {
    left: 5px;
    top: 5px;
    position: absolute;
    z-index: 20;
}

</style>